<template>
  <div class="separator">&nbsp;</div>
</template>

<script setup lang="ts">
defineProps({})
// No need to import Vue or define the component options
</script>

<style>
.separator {
  /* border-top: 1px solid var(--border-secondary); */
  height: 1px;
  background-color: var(--border-secondary);
}
</style>
